import React from 'react';
import { CALL_SERVICES, callServiceHref } from '../../lib/callServices';

/**
 * 휴대폰 메뉴(오른쪽에서 열리는 메뉴 판)의 블랭킷 전화 상담 목록 — 대표 7964(2026-10-22)
 * "핸드폰 기준에서 왼쪽 메뉴 화면, 거기 내용에도 상세하게 잘 쳐 넣으라고요."
 * 서비스마다 이름·무엇을 하는 전화인지·사이트 첫 화면 문장·전화번호. 누르면 그 사이트(출처 꼬리표 socialdataai_menu).
 * 목록·문구·번호의 정본은 lib/callServices — 첫 화면 소개 칸·대시보드 카드와 같다.
 */
export const MobileMenuCallServices: React.FC<{ onNavigate: () => void }> = ({ onNavigate }) => (
    <div className="mt-4 pt-4 border-t border-[#262626]">
        <div className="mb-2 flex items-baseline justify-between gap-2 px-3">
            <h3 className="text-[11px] font-semibold uppercase tracking-wider text-[#E58A74]">전화 상담</h3>
            <span className="text-[10px] text-[#8b95a1] break-keep">가입·카드 없이 처음 3분 무료</span>
        </div>
        <nav className="space-y-1">
            {CALL_SERVICES.map((s) => (
                <a
                    key={s.key}
                    href={callServiceHref(s, 'menu')}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onNavigate}
                    className="group flex items-start gap-3 rounded-xl px-3 py-2.5 transition-all duration-200 hover:bg-[#1a1a1a]"
                >
                    <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-[#3a2622] bg-[#1a110e]">
                        <s.icon className="h-4 w-4 text-[#E58A74]" />
                    </div>
                    <div className="min-w-0 flex-1">
                        <div className="flex items-baseline gap-1.5">
                            <span className="shrink-0 text-[14px] font-medium text-white">{s.name}</span>
                            <span className="truncate text-[11px] text-[#f2b8a8]">{s.kind}</span>
                        </div>
                        <p className="mt-0.5 text-[11px] leading-snug text-[#8b95a1] break-keep">{s.tagline}</p>
                        <p className="mt-0.5 text-[11px] font-semibold tabular-nums text-[#F2C29B]">{s.phone ?? '전화번호 준비 중'}</p>
                    </div>
                </a>
            ))}
        </nav>
    </div>
);
